import 'primereact/resources/primereact.css'
import 'primeicons/primeicons.css'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import './App.css';
import Router from './routes/router';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './components/footer/footer';
import NavBar from './components/navbar2/navbar';

function App() {

  return (
    <>
      <NavBar />
      <Router />
      <Footer />
    </>
  );
}

export default App;
